// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WishLists-space1-ShkNz {
	margin-bottom: 6px !important;
}

.WishLists-space2-Rb_OW {
	margin-bottom: 12px !important;
}

.WishLists-space3-LOI4X {
	margin-bottom: 18px !important;
}

.WishLists-space4-rst8f {
	margin-bottom: 24px !important;
}

.WishLists-space5-MOhih {
	margin-bottom: 30px !important;
}

.WishLists-space6-rBz3_ {
	margin-bottom: 36px !important;
}

.WishLists-space7-TEHlP {
	margin-bottom: 42px !important;
}

.WishLists-spaceTop8-x7BT2 {
	margin-bottom: 48px !important;
}

.WishLists-spaceTop1-IYEW2 {
	margin-top: 6px !important;
}

.WishLists-spaceTop2-SspNx {
	margin-top: 12px !important;
}

.WishLists-spaceTop3-gy2Q8 {
	margin-top: 18px !important;
}

.WishLists-spaceTop4-Grxal {
	margin-top: 24px !important;
}

.WishLists-spaceTop5-h8ruc {
	margin-top: 30px !important;
}

.WishLists-spaceTop6-n13Gw {
	margin-top: 36px !important;
}

.WishLists-spaceTop7-jwVBX {
	margin-top: 42px !important;
}

.WishLists-spaceTop8-x7BT2 {
	margin-top: 48px !important;
}

.WishLists-noMargin-SNFdK {
	margin: 0px !important;
}

.WishLists-padding1-n6B4t {
	padding-bottom: 6px !important;
}

.WishLists-padding2-Z6osJ {
	padding-bottom: 12px !important;
}

.WishLists-padding3-ICLN7 {
	padding-bottom: 18px !important;
}

.WishLists-padding4-mLEp8 {
	padding-bottom: 24px !important;
}

.WishLists-padding5-Ab4ae {
	padding-bottom: 30px !important;
}

.WishLists-padding6-kQZLs {
	padding-bottom: 36px !important;
}

.WishLists-padding7-I17_3 {
	padding-bottom: 42px !important;
}

.WishLists-paddingTop1-Mow_N {
	padding-top: 6px !important;
}

.WishLists-paddingTop2-lFoCi {
	padding-top: 12px !important;
}

.WishLists-paddingTop3-lO2Q1 {
	padding-top: 18px !important;
}

.WishLists-paddingTop4-jCM67 {
	padding-top: 24px !important;
}

.WishLists-paddingTop5-L19AV {
	padding-top: 30px !important;
}

.WishLists-paddingTop6-D8rAZ {
	padding-top: 36px !important;
}

.WishLists-paddingTop7-KFrL5 {
	padding-top: 42px !important;
}

.WishLists-noPadding-jv3g0 {
	padding: 0px !important;
}

.WishLists-textBold-faMoL {
	font-weight: 500 !important;
}

.WishLists-textBolder-O8_Oa {
	font-weight: 700 !important;
}

.WishLists-textNormal-Uvq5v {
	font-weight: normal !important;
}

.WishLists-spaceBottom20-UMQ3f {
	margin-bottom: 20px;
}

.WishLists-spaceBottom10-bpmgp {
	margin-bottom: 10px;
}

.WishLists-marginNone-PKYrD {
	margin: 0;
}

.WishLists-spaceBottom15-Fc4rS {
	margin-bottom: 15px;
}

.WishLists-marginTopNone-ECujy {
	margin-top: 0;
}

.WishLists-spaceTop11-JsXC3 {
	margin-top: 11px;
}

.WishLists-spaceTop21-JB8BE {
	margin-top: 21px;
}

.WishLists-spaceTop20-v1aGq {
	margin-top: 20px;
}

.WishLists-spaceTop10-B74lg {
	margin-top: 10px;
}

/*New Design Text Colors */

.WishLists-textDarkBlue-NWDAW {
	color: rgb(20, 39, 94) !important;
}

.WishLists-textLightBlue-uz7Zp {
	color: rgb(57, 87, 106) !important;
}

.WishLists-textLightSandleGreen-DlVl_ {
	color: rgb(76, 86, 41) !important;
}

.WishLists-textLightBrown-HzbzB {
	color: rgb(115, 79, 33) !important;
}

.WishLists-textMediumMaroon-W2odG {
	color: rgb(87, 37, 51) !important;
}

.WishLists-textBrown-UJr1l {
	color: rgb(160, 47, 24) !important;
}

.WishLists-textMaroon-qQMxf {
	color: rgb(155, 49, 67) !important;
}

.WishLists-textDarkBrown-_7MgG {
	color: rgb(83, 18, 16) !important;
}

.WishLists-textMediumBrown-zQ92Z {
	color: rgb(142, 28, 10) !important;
}

.WishLists-textSkyBlue-f5eo7 {
	color: rgb(37, 117, 141) !important;
}

.WishLists-textGray-DDSEC {
	color: rgb(77, 65, 51) !important;
}

.WishLists-button-X7LLL {
	font-size: 18px !important;
}

.WishLists-landingTitle-_7f4m {
	font-size: 26px;
	margin: 0;
	font-weight: 600;
	display: inline-block;
}

.WishLists-landingContentTitle-pEE3y {
	font-size: 24px;
	margin: 0px 0px 18px 0px;
}

.WishLists-landingContent-HB24T {
	margin-top: 60px;
	margin-bottom: 100px;
}

.WishLists-noPadding-jv3g0 {
	padding: 0px;
}

.WishLists-pullRight-shSQR {
	float: right;
}

.WishLists-noMargin-SNFdK {
	margin: 0px;
}

.WishLists-noPadding-jv3g0 {
	padding: 0px;
}

/** SyncCalendar Start **/

.WishLists-marginTop-aydZc {
	margin-top: 40px !important;
}

.WishLists-flexWish-iix08 {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
	-ms-flex-line-pack: center;
	    align-content: center;
	margin-bottom: 33px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
	gap: 10px;
}

.WishLists-countingCss-yGEYV {
	font-size: 26px;
	margin-left: 3px;
	font-weight: 600;
}

.WishLists-smPosition-NsiPt {
	font-size: 16px !important;
}

.WishLists-noListSubHeading-ZarOP {
	color: var(--secondary-foreground);
	font-size: 18px;
	max-width: 540px;
	margin: 20px auto 0;
}

.WishLists-textCenter-mxPqf {
	text-align: center;
}

.WishLists-addNewBtn-bDlv4 {
	padding: 13px 15px;
	margin-top: 30px;
	display: inline-block;
}

.WishLists-wishGrid-hdnrs {
	display: grid;
	grid-template: repeat(3, 1fr) / repeat(4, 1fr);
	grid-gap: 33px;
}

@media screen and (max-width: 767px) {
	.WishLists-smPosition-NsiPt {
		float: none;
	}

	.WishLists-smTop4-BuYKa {
		margin-top: 24px;
	}

	.WishLists-imgWidth-GPyeW {
		width: 100%;
	}


	.WishLists-wishGrid-hdnrs {
		grid-template-columns: 100%;
		grid-gap: 20px;
	}
}

/** SyncCalendar End **/`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/WishLists/WishLists.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC1NA;CACC,0BAA0B;AAC3B;;AAEA;CACC,eAAe;CACf,SAAS;CACT,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,wBAAwB;AACzB;;AAEA;CACC,gBAAgB;CAChB,oBAAoB;AACrB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,YAAY;AACb;;AAEA,yBAAyB;;AAEzB;CACC,2BAA2B;AAC5B;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;CAC9B,0BAAqB;KAArB,qBAAqB;CACrB,mBAAmB;CACnB,mBAAe;KAAf,eAAe;CACf,SAAS;AACV;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,kCAAkC;CAClC,eAAe;CACf,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,aAAa;CACb,8CAA8C;CAC9C,cAAc;AACf;;AAEA;CACC;EACC,WAAW;CACZ;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;CACZ;;;CAGA;EACC,2BAA2B;EAC3B,cAAc;CACf;AACD;;AAEA,uBAAuB","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../helpers.css';\n\n.button {\n\tfont-size: 18px !important;\n}\n\n.landingTitle {\n\tfont-size: 26px;\n\tmargin: 0;\n\tfont-weight: 600;\n\tdisplay: inline-block;\n}\n\n.landingContentTitle {\n\tfont-size: 24px;\n\tmargin: 0px 0px 18px 0px;\n}\n\n.landingContent {\n\tmargin-top: 60px;\n\tmargin-bottom: 100px;\n}\n\n.noPadding {\n\tpadding: 0px;\n}\n\n.pullRight {\n\tfloat: right;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\n.noPadding {\n\tpadding: 0px;\n}\n\n/** SyncCalendar Start **/\n\n.marginTop {\n\tmargin-top: 40px !important;\n}\n\n.flexWish {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-content: center;\n\tmargin-bottom: 33px;\n\tflex-wrap: wrap;\n\tgap: 10px;\n}\n\n.countingCss {\n\tfont-size: 26px;\n\tmargin-left: 3px;\n\tfont-weight: 600;\n}\n\n.smPosition {\n\tfont-size: 16px !important;\n}\n\n.noListSubHeading {\n\tcolor: var(--secondary-foreground);\n\tfont-size: 18px;\n\tmax-width: 540px;\n\tmargin: 20px auto 0;\n}\n\n.textCenter {\n\ttext-align: center;\n}\n\n.addNewBtn {\n\tpadding: 13px 15px;\n\tmargin-top: 30px;\n\tdisplay: inline-block;\n}\n\n.wishGrid {\n\tdisplay: grid;\n\tgrid-template: repeat(3, 1fr) / repeat(4, 1fr);\n\tgrid-gap: 33px;\n}\n\n@media screen and (max-width: 767px) {\n\t.smPosition {\n\t\tfloat: none;\n\t}\n\n\t.smTop4 {\n\t\tmargin-top: 24px;\n\t}\n\n\t.imgWidth {\n\t\twidth: 100%;\n\t}\n\n\n\t.wishGrid {\n\t\tgrid-template-columns: 100%;\n\t\tgrid-gap: 20px;\n\t}\n}\n\n/** SyncCalendar End **/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `WishLists-space1-ShkNz`,
	"space2": `WishLists-space2-Rb_OW`,
	"space3": `WishLists-space3-LOI4X`,
	"space4": `WishLists-space4-rst8f`,
	"space5": `WishLists-space5-MOhih`,
	"space6": `WishLists-space6-rBz3_`,
	"space7": `WishLists-space7-TEHlP`,
	"spaceTop8": `WishLists-spaceTop8-x7BT2`,
	"spaceTop1": `WishLists-spaceTop1-IYEW2`,
	"spaceTop2": `WishLists-spaceTop2-SspNx`,
	"spaceTop3": `WishLists-spaceTop3-gy2Q8`,
	"spaceTop4": `WishLists-spaceTop4-Grxal`,
	"spaceTop5": `WishLists-spaceTop5-h8ruc`,
	"spaceTop6": `WishLists-spaceTop6-n13Gw`,
	"spaceTop7": `WishLists-spaceTop7-jwVBX`,
	"noMargin": `WishLists-noMargin-SNFdK`,
	"padding1": `WishLists-padding1-n6B4t`,
	"padding2": `WishLists-padding2-Z6osJ`,
	"padding3": `WishLists-padding3-ICLN7`,
	"padding4": `WishLists-padding4-mLEp8`,
	"padding5": `WishLists-padding5-Ab4ae`,
	"padding6": `WishLists-padding6-kQZLs`,
	"padding7": `WishLists-padding7-I17_3`,
	"paddingTop1": `WishLists-paddingTop1-Mow_N`,
	"paddingTop2": `WishLists-paddingTop2-lFoCi`,
	"paddingTop3": `WishLists-paddingTop3-lO2Q1`,
	"paddingTop4": `WishLists-paddingTop4-jCM67`,
	"paddingTop5": `WishLists-paddingTop5-L19AV`,
	"paddingTop6": `WishLists-paddingTop6-D8rAZ`,
	"paddingTop7": `WishLists-paddingTop7-KFrL5`,
	"noPadding": `WishLists-noPadding-jv3g0`,
	"textBold": `WishLists-textBold-faMoL`,
	"textBolder": `WishLists-textBolder-O8_Oa`,
	"textNormal": `WishLists-textNormal-Uvq5v`,
	"spaceBottom20": `WishLists-spaceBottom20-UMQ3f`,
	"spaceBottom10": `WishLists-spaceBottom10-bpmgp`,
	"marginNone": `WishLists-marginNone-PKYrD`,
	"spaceBottom15": `WishLists-spaceBottom15-Fc4rS`,
	"marginTopNone": `WishLists-marginTopNone-ECujy`,
	"spaceTop11": `WishLists-spaceTop11-JsXC3`,
	"spaceTop21": `WishLists-spaceTop21-JB8BE`,
	"spaceTop20": `WishLists-spaceTop20-v1aGq`,
	"spaceTop10": `WishLists-spaceTop10-B74lg`,
	"textDarkBlue": `WishLists-textDarkBlue-NWDAW`,
	"textLightBlue": `WishLists-textLightBlue-uz7Zp`,
	"textLightSandleGreen": `WishLists-textLightSandleGreen-DlVl_`,
	"textLightBrown": `WishLists-textLightBrown-HzbzB`,
	"textMediumMaroon": `WishLists-textMediumMaroon-W2odG`,
	"textBrown": `WishLists-textBrown-UJr1l`,
	"textMaroon": `WishLists-textMaroon-qQMxf`,
	"textDarkBrown": `WishLists-textDarkBrown-_7MgG`,
	"textMediumBrown": `WishLists-textMediumBrown-zQ92Z`,
	"textSkyBlue": `WishLists-textSkyBlue-f5eo7`,
	"textGray": `WishLists-textGray-DDSEC`,
	"button": `WishLists-button-X7LLL`,
	"landingTitle": `WishLists-landingTitle-_7f4m`,
	"landingContentTitle": `WishLists-landingContentTitle-pEE3y`,
	"landingContent": `WishLists-landingContent-HB24T`,
	"pullRight": `WishLists-pullRight-shSQR`,
	"marginTop": `WishLists-marginTop-aydZc`,
	"flexWish": `WishLists-flexWish-iix08`,
	"countingCss": `WishLists-countingCss-yGEYV`,
	"smPosition": `WishLists-smPosition-NsiPt`,
	"noListSubHeading": `WishLists-noListSubHeading-ZarOP`,
	"textCenter": `WishLists-textCenter-mxPqf`,
	"addNewBtn": `WishLists-addNewBtn-bDlv4`,
	"wishGrid": `WishLists-wishGrid-hdnrs`,
	"smTop4": `WishLists-smTop4-BuYKa`,
	"imgWidth": `WishLists-imgWidth-GPyeW`
};
module.exports = ___CSS_LOADER_EXPORT___;
